import { render, staticRenderFns } from "./GameTagsInputs.vue?vue&type=template&id=1a363ba9&scoped=true"
import script from "./GameTagsInputs.vue?vue&type=script&lang=js"
export * from "./GameTagsInputs.vue?vue&type=script&lang=js"
import style0 from "./GameTagsInputs.vue?vue&type=style&index=0&id=1a363ba9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a363ba9",
  null
  
)

export default component.exports